export default "/assets/images/technology-hero.c8cb345c7fbbb967.webp";